import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheckIcon, DocumentTextIcon } from '@heroicons/react/24/outline';
import ServicesOfferedComponent from './ServicesOfferedComponent';

const LandingComponent = () => {
  return (
    <div>
      <h1 className="text-4xl lg:text-4xl font-bold text-blue-100 text-center py-6 pt-8 bg-blue-900 shadow-md">
        <span className='text-green-900'></span> Institute for Patient Safety Africa – <span className='text-green-100'>IPSA</span>
      </h1>
      <section className="min-h-screen bg-white dark:bg-gray-200 py-10 flex flex-col lg:flex-row items-around justify-center">         
        {/* Left Side: */}
        <div className="lg:w-1/2 w-full flex flex-col items-center text-center px-4 mb-10 lg:mb-0">
          <div className="relative w-full ">
            <img
              src="/images/landing.jpg"
              alt="IPSA Logo"
              className="w-full h-auto rounded-lg shadow-lg transform transition duration-500 hover:scale-105"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-blue-900 bg-opacity-70 text-white text-sm p-2 rounded-b-lg">
              IPSA: Advancing Patient Safety Across Africa
            </div>
          </div>

          <div className="flex space-x-4 mt-6 mb-4">
            <ShieldCheckIcon className="h-20 w-20 text-green-800" />
            <DocumentTextIcon className="h-20 w-20 text-green-800" />
          </div>

          <p className="text-xl font-semibold text-gray-700 dark:text-gray-900 max-w-md">
            Empowering Healthcare Institutions to Measure, Learn, and Continuously Improve Patient Safety
          </p>        

          <p className="text-gray-700 dark:text-gray-800 italic text-center mt-6">
            <Link className="text-blue-900 font-bold underline" to="/register">
              Join IPSA
            </Link>{' '}
            to streamline your operations, improve compliance, and elevate patient safety across your institution.
          </p>
        </div>
        {/* Right Side: */}
        <div className="lg:w-3/4 w-full px-2">    
          <p className="block mb-4 bg-blue-800 text-center text-lg text-white px-8 py-6 rounded-lg ">
            <span className='mb-4 block'>
              The <strong>Institute for Patient Safety Digital Platform </strong> is a web and mobile-based application designed to support healthcare organizations in their journey toward patient safety excellence. The system provides a unified digital ecosystem that enables hospitals, clinics, and training institutions to assess, learn, improve, and demonstrate patient safety performance through evidence-based frameworks. <br/>
            </span>
            <span >
              The platform aligns with the <strong>World Health Organization (WHO) Global Patient Safety Action Plan (2021–2030) , Joint Commission International (JCI) standards, and ISQua </strong> principles of quality improvement. We provide:
            </span>
          </p>  
          <div className="mb-2">
            <ServicesOfferedComponent />
          </div>    
        </div>
      </section>
    </div>
  );
};

export default LandingComponent;
